module.exports = __webpack_public_path__ + "img/login_bg.b4a0299f.png";